import { render, staticRenderFns } from "./PerfilEndereco.vue?vue&type=template&id=5035fdd8&scoped=true"
import script from "./PerfilEndereco.vue?vue&type=script&lang=js"
export * from "./PerfilEndereco.vue?vue&type=script&lang=js"
import style0 from "./PerfilEndereco.vue?vue&type=style&index=0&id=5035fdd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5035fdd8",
  null
  
)

export default component.exports